import { Injectable } from "@angular/core";
import { BeeUser } from "src/app/domain/core/models/bee-user";
import { GenericItemPermission } from "src/app/domain/core/models/generic-item-permission";

@Injectable()
export abstract class IPermissionService {
  abstract hasPermission(permission: GenericItemPermission, user?: BeeUser): boolean;
}